import React from "react";
import { Accordion, AccordionSummary, AccordionDetails } from "@material-ui/core";
// Modus Icons - solid font for chevrons
import '@trimble-oss/modus-icons/dist/modus-solid/fonts/modus-icons.css';

/**
 * Reusable accordion component for security methods
 * @param {Object} props
 * @param {string} props.id - Unique identifier for accessibility (e.g., 'passkeys', 'authenticator')
 * @param {boolean} props.expanded - Whether the accordion is expanded
 * @param {function} props.onChange - Handler for accordion state change
 * @param {React.ReactNode} props.icon - Icon element to display in the header
 * @param {React.ReactNode} props.title - Title text/element
 * @param {React.ReactNode} [props.subtitle] - Optional subtitle/count element
 * @param {React.ReactNode} props.children - Accordion content
 */
const SecurityMethodAccordion = ({
     id,
     expanded,
     onChange,
     icon,
     title,
     subtitle,
     children
}) => {
     return (
          <Accordion 
               expanded={expanded} 
               onChange={onChange}
               className="security-method-accordion"
               data-test-id="security-method-accordion"
          >
               <AccordionSummary
                    expandIcon={
                         <i 
                              className={`modus-icons accordion-expand-icon ${expanded ? 'expanded' : 'collapsed'}`} 
                              aria-hidden="true"
                              data-test-id="security-method-accordion-expand-icon"
                         >
                              {expanded ? 'expand_less_circle' : 'expand_more_circle'}
                         </i>
                    }
                    aria-controls={`${id}-content`}
                    id={`${id}-header`}
                    className="security-method-accordion-summary"
               >
                    <div className="security-method-accordion-header">
                         <h5 className="security-method-section-title" data-test-id="security-method-accordion-title">
                              {icon}
                              {title}
                         </h5>
                         {subtitle && (
                              <span className="passkey-count" data-test-id="security-method-accordion-subtitle">
                                   {subtitle}
                              </span>
                         )}
                    </div>
               </AccordionSummary>
               <AccordionDetails className="security-method-accordion-details">
                    <div className="security-method-accordion-content">
                         {children}
                    </div>
               </AccordionDetails>
          </Accordion>
     );
};

export default SecurityMethodAccordion;
